(ns frontend.view.profile.events
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.actions.account :as account-actions]
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.nylas :as nylas]
   [frontend.controller.websocket.event :as ws]
   [frontend.utils :as fu]
   [frontend.view.modals.choice-confirmation.view :as choice-confirmation]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.nylas-connect.view :as nylas-connect]
   [frontend.view.profile.db :as db]
   [potpuri.core :as potpuri]
   [promesa.core :as p]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::nylas-url-failed
 (fn [{db :db} [_ resp]]
   ))

(rf/reg-event-fx
 ::nylas-url-ok
 (fn [{db :db} [_ resp]]
   (let [url (:body resp)]
     (js/console.log "REDIRECT URL : " url)
     (aset js/window.location
           "href"
           url)
     {})))


(rf/reg-event-fx
 ::start-nylas-auth
 (fn [{db :db} [_ email provider]]
   {::ws/send {:id         :nylas/get-connect-url
               :body       {:email email
                            :provider provider}
               :on-success [::nylas-url-ok]
               :on-error   [::nylas-url-failed]}}))

(defn clean-edits!
  []
  (swap! db/state dissoc :edit-personal :picture))

;;empty value handling
(defn blank->nil
  [val]
  (when-not (string/blank? val)
    val))

(defn modify-my-info!
  [k v]
  (let [old-val (blank->nil (get @db/account k))]
    (if (or (nil? v) (= (blank->nil v) old-val))
      (swap! db/state potpuri/dissoc-in [:edit-personal k])
      (swap! db/state assoc-in [:edit-personal k] v))))

(defn modify-file!
  [e]
  (swap! db/state
         assoc
         :picture
         (-> e
             .-target
             .-files
             (aget 0))))

(defn save!
  []
  (let [{:keys [edit-personal picture]} @db/state
        {:keys [:db/id]} @db/account]
    (when-not (nil? picture)
      (conn/add-user-image! {:file     picture
                             :filename (.-name picture)}
                            id))
    (js/console.log "SAVE : " @db/state)
    (account-actions/*->update-personal
     (assoc edit-personal :db/id id)
     clean-edits!
     #(logging/error (str "error! updating personal " %)))))


(defn save-personal
  [k v]
  (let [{:keys [:db/id]} @db/account]
    (js/console.log "Save personal : " id " " k " > " v)
    (account-actions/*->update-personal
     {:db/id id
      k      v}
     #(js/setTimeout clean-edits! 1000) ;;TODO timeout added, because clean function flickers the old value when saving. Better solution?
     #(logging/error (str "error! updating personal " %)))))

(defn connect-nylas
  [_]
  (modals/open-modal! nylas-connect/modal-key
                      {:on-confirm! (fn [{:keys [default-nylas-privacy email sync-contacts? close-modal! provider]}]
                                      (account-actions/*->update-personal
                                       {:db/id                         (:db/id @session/account)
                                        :account/nylas-sync-contacts?  sync-contacts?
                                        :account/default-nylas-privacy default-nylas-privacy}
                                       (fn [_]
                                         (close-modal!)
                                         (rf/dispatch [::start-nylas-auth email provider]))
                                       (fn [e]
                                         (logging/error (str "error! updating nylas defaults " e))
                                         )))}))

(defn update-nylas-sync-contacts
  [sync-contacts? on-success! on-error!]
  (account-actions/*->update-personal
   {:db/id                        (:db/id @session/account)
    :account/nylas-sync-contacts? (boolean sync-contacts?)}
   on-success!
   on-error!))

(defn disconnect-nylas
  [_]
  (modals/open-modal! choice-confirmation/modal-key
                      {:body           [:p.mb-4.font-bold (loc/tr :personal-profile/email-sync-disconnect-account-confirmation-text)]
                       :confirm-text   (loc/tr :personal-profile/email-sync-disconnect-account-button)
                       :radio-text-yes (loc/tr :personal-profile/email-sync-disconnect-account-confirmation-leave)
                       :radio-text-no  (loc/tr :personal-profile/email-sync-disconnect-account-confirmation-stay)
                       :on-confirm     (fn [_]
                                         (-> (conn/sendp! :nylas/disconnect {})
                                             (p/then (fn [args]))
                                             (p/catch (fn [args]))))}))

(defn reset-mfa!
  [account-id tenant-id]
  (let [msg {:account-id account-id
             :tenant-id  tenant-id}
        on-success! (fn [response]
                      (let [body (:body response)]
                        (reset! db/mfa (merge body
                                              {:show-image? true
                                               :show-key?   true}))
                        ))
        on-error! (fn [e]
                    (logging/error (str "error! reset-mfa " e)))]
    (account-actions/*->reset-mfa
     msg
     on-success!
     on-error!)))

(defn assign-mfa!
  []
  (let [{:keys [mfa-1 mfa-2]} @db/mfa
        mfa-1 (-> mfa-1
                  str
                  (string/replace #"[^0-9]" "")
                  fu/str->int)
        mfa-1 (if (and (number? mfa-1)
                       (> mfa-1 0))
                mfa-1
                0)
        mfa-2 (-> mfa-2
                  str
                  (string/replace #"[^0-9]" "")
                  fu/str->int)
        mfa-2 (if (and (number? mfa-2)
                       (> mfa-2 0))
                mfa-2
                0)
        msg {:mfa-1 mfa-1
             :mfa-2 mfa-2}
        on-success! (fn [response]
                      (let [body (:body response)]
                        (reset! db/mfa {:info :mfa-key-updated})
                        ))
        on-error! (fn [e]
                    (let [error (-> e
                                    ex-data
                                    :message)]
                      (logging/error (str "error! assign-mfa " e))
                      (when (keyword? error)
                        (swap! db/mfa assoc :error error))))]
    (account-actions/*->assign-mfa
     msg
     on-success!
     on-error!)))

(defn deactivate-mfa!
  [account-id]
  (let [msg {:account-id account-id}
        on-success! (fn [response]
                      (let [body (:body response)]
                        (reset! db/mfa {:info :mfa-key-deactivated})
                        ))
        on-error! (fn [e]
                    (let [error (-> e
                                    ex-data
                                    :message)]
                      (logging/error (str "error! deactivate-mfa " e))
                      (when (keyword? error)
                        (swap! db/mfa assoc :error error))))]
    (account-actions/*->deactivate-mfa
     msg
     on-success!
     on-error!)))

(defn update-nylas-privacy!
  [account new-privacy-value update-past-messages? on-ok! on-error!]
  (let [{:keys [:db/id]} account
        msg {:db/id                         id
             :account/default-nylas-privacy new-privacy-value
             :update-past-messages?         (boolean update-past-messages?)}]
    (account-actions/*->update-personal
     msg
     on-ok!
     on-error!)))


(rf/reg-event-fx
 ::side-nav-clicked
 (fn [{db :db} [_ path]]
   (js/console.log "Navigate to : " path)
   {::routing/old-routing {:path-args path}}))
